import React, { useState } from 'react';
import { PATHS } from 'src/common/constants';
import HeadingWithDetails from '../../components/HeadingWithDetails';
import Breadcrumb from '../../components/Breadcrumb';
import Card from '../../components/Card';
import Avatar from '../../components/Avatar';
import Tenant from '../../components/Tenant';
import Tabs from '../../components/Tabs';
import CommonAreaServiceRequests from './CommonAreaServiceRequests';
import CommonAreaAssets from './CommonAreaAssets';
import useCommonAreaPageData, {
  UseCommonAreaPageDataReturn,
} from './CustomHooks/useCommonAreaPageData';
import { variables } from 'src/Tenants';
import { onRequestPhoneCall } from 'src/helpers/validationHelper';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';
import Loader from 'src/components/Loader';

interface CommonAreaProps {
  match: any;
  location?: any;
  [key: string]: any;
}

const CommonArea = ({ match, location }: CommonAreaProps) => {
  const {
    property,
    commonArea,
    commonAreaAssets,
    serviceRequests,
    loading,
  }: UseCommonAreaPageDataReturn = useCommonAreaPageData(
    match,
    location?.state
  );

  const [isOpen, setIsOpen] = useState<any>(false);

  if (loading || !commonArea) {
    return <Loader />;
  }

  return (
    <WithNavigation
      title={
        commonArea.customLabel ? commonArea.customLabel : commonArea.name
      }
      top={
        <HeadingWithDetails
          style={{
            backgroundImage: `url(/assets/banner-property.png)`,
          }}
          breadcrumb={
            <Breadcrumb
              to={PATHS.PROPERTIES_VIEW.replace(':id', property.id)}
              label={property.name}
            />
          }
          headline={
            commonArea.customLabel ? commonArea.customLabel : commonArea.name
          }
          items={[
            <Card
              title={variables.propertyDeveloper}
              body={
                property.propertyManager &&
                property.propertyManager.firstname ? (
                  <Tenant
                    headline={
                      <a
                        href={PATHS.CONTACTS_VIEW.replace(
                          ':id',
                          property.propertyManager.id
                        )}
                      >
                        {property.propertyManager.firstname}{' '}
                        {property.propertyManager.lastname}
                      </a>
                    }
                    strapline={onRequestPhoneCall(
                      property.propertyManager.phone
                    )}
                    avatar={
                      <div
                        onClick={() =>
                          setIsOpen(
                            !!property.propertyManager.profileImage
                          )
                        }
                      >
                        <Avatar
                          badge="property-manager"
                          url={property.propertyManager.profileImage}
                        />
                        <ReusableLightbox
                          isOpen={Boolean(isOpen)}
                          onClose={() => setIsOpen(false)}
                          image={property.propertyManager.profileImage}
                        />
                      </div>
                    }
                  />
                ) : (
                  <div style={{ textAlign: 'center' }}> Unassigned </div>
                )
              }
            />,
            <Card
              title="Strata Manager"
              body={
                property.strataManager && property.strataManager.firstname ? (
                  <Tenant
                    headline={
                      <a
                        href={PATHS.CONTACTS_VIEW.replace(
                          ':id',
                          property.strataManager.id
                        )}
                      >
                        {property.strataManager.firstname}{' '}
                        {property.strataManager.lastname}
                      </a>
                    }
                    strapline={onRequestPhoneCall(
                      property.strataManager.phone
                    )}
                    avatar={
                      <div
                        onClick={() =>
                          setIsOpen(
                            !!property.strataManager.profileImage
                          )
                        }
                      >
                        <Avatar
                          badge="strata-manager"
                          url={property.strataManager.profileImage}
                        />
                        <ReusableLightbox
                          isOpen={Boolean(isOpen)}
                          onClose={() => setIsOpen(false)}
                          image={property.strataManager.profileImage}
                        />
                      </div>
                    }
                  />
                ) : (
                  <div style={{ textAlign: 'center' }}> Unassigned </div>
                )
              }
            />,
          ]}
        />
      }
      bottom={
        <Tabs
          from={'CommonArea'}
          items={[
            {
              label: 'Assets',
              count: commonAreaAssets.length.toString(),
              content: (
                <CommonAreaAssets
                  commonArea={commonArea}
                  property={property}
                />
              ),
            },
            {
              label: 'Service Requests',
              count: serviceRequests.length.toString(),
              content: (
                <CommonAreaServiceRequests
                  commonArea={commonArea}
                  property={property}
                />
              ),
            },
          ]}
        />
      }
    />
  );
};

export default CommonArea;
